module.exports = __webpack_public_path__ + "media/images/pic/hero/hall-49e7adc67859ef3b0e298005403fc3d0.webp";